import { Injectable } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem, copyArrayItem } from '@angular/cdk/drag-drop';
import { Model } from '../Models/model';
import { GlobalDragStateService } from './global-drag-state.service';

@Injectable({
  providedIn: 'root'
})
export class DragDropService {
  constructor(private globalDragState: GlobalDragStateService) { }
  listOfid() {
    return "['Suites','Features','Scenarios','Steps']"
  }
  drop(event: CdkDragDrop<Model[]>, copyDataNotId = 0) {
    if (event.previousContainer.id === event.container.id) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      copyArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }

  // Method to handle drag start
  onDragStarted(): void {
    this.globalDragState.setDragging(true);
  }

  // Method to handle drag ended
  onDragEnded(): void {
    this.globalDragState.setDragging(false);
  }
}
